module.exports = __webpack_public_path__ + "img/injection-prescription.fab3ca61.svg";